import React from 'react';

import type {ListItemViewModel} from 'llm/chat-library/shared/list-detail/listDetailTypes';
import type {RoutineExample} from 'llm/routines/routineExamples';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

/**
 * Maps a pre-configured {@link RoutineExample} to a listing-view row for the Background agents tab's
 * "Example agents" group. The row mirrors a real agent row visually (icon + title + description) so
 * examples read as templates, but is intentionally action-free — no toggle, overflow menu, or
 * primary action. Clicking the row opens the create form prefilled from the example.
 */
export default function buildListItemViewModelFromExample(example: RoutineExample): ListItemViewModel {
  return {
    id: example.id,
    title: example.label,
    icon: <BenchlingIcon icon={example.icon} aria-hidden={true} />,
    description: example.formState.prompt,
  };
}
